<template>
<div class="footer_maxbox">
  <!-- 首頁尾部 -->
  <div class="footer_box">
    <!-- 内容 -->
    <div class="footer">
      <!-- 左边区块 -->
      <div class="footer_left">
        <!--台易購金融科技股份有限公司 -->
        <div class="company_box">
          <h3>台易購金融科技股份有限公司</h3>
          <p>各國網路商城代付．微信/支付寶儲值．台灣合法在地永續經營</p>
          <p>電話.02 2212 5312　|　傳真：02 2212 3192</p>
					<p>郵箱：TYG8899@outlook.com</p>
          <p>地址：新北市231新店區安興路117號12樓之7</p>
        </div>
        <!-- logo_partner -->
        <div class="logo_partner_box">
          <div class="logo_partner">
            <img src="../../assets/img/common/logo_partner01.png" alt="">
            <img src="../../assets/img/common/logo_partner02.png" alt="">
            <img src="../../assets/img/common/logo_partner03.png" alt="">
            <img src="../../assets/img/common/logo_partner04.png" alt="">
            <img src="../../assets/img/common/logo_partner05.png" alt="">
          </div>
          <div class="logo_sns">
            <img src="../../assets/img/common/sns.png" alt="">
          </div>
        </div>
      </div>
      <!-- 中间区块-二维码 -->
      <div class="footer_code">
        <img src="../../assets/img/common/qr_code.png" alt="">
      </div>
      <!-- 右边区块 -->
      <div class="footer_right">
        <ul>
          <li>about</li>
          <li @click="testClick('1')">關於我們</li>
          <li>使用指南</li>
          <li>常見問題</li>
          <li>隱私政策</li>
        </ul>
         <ul>
          <li>product</li>
          <li>收款工具</li>
          <li>付款工具</li>
          <li>店舖管理</li>
          <li>金流服務</li>
        </ul>
         <ul>
          <li>service</li>
          <li>支援中心</li>
          <li>會員條款</li>
          <li>店舖管理</li>
          <li>商務合作</li>
        </ul>
      </div>
    </div>
    <!-- copyright -->
  </div>
  <!-- copyright -->
  <div class="copyright">
    COPYRIGHT © TYG Financial Technology INC. ALL RIGHTS RESERVED.
  </div>
</div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    testClick(id){
      this.$router.push("/test/" + id);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 首頁尾部 */
  .footer_box {
    background: #777777;
    height: 292px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 1180px;
  }
  .footer {
    overflow: hidden;
    font-size: 13px;
    color: #ffffff;
  }
  .footer > div {
     float: left;
  }
  /* 左边区块 */
  .footer_left {
    box-sizing: border-box;
    width: 630px;
  }
   .footer_left .company_box {
     height: 98px;
     padding-left: 110px;
     background: url("../../assets/img/common/logo_company.png") no-repeat top left;
     background-size: contain;
   }
   .footer_left .company_box h3 {
     font-weight: bold;
     line-height: 28px;
     letter-spacing: 4px;
   }
   .footer_left .company_box p {
     line-height: 20px;
     letter-spacing: 1px;
      font-weight: 100;
   }
   .footer_left .logo_partner_box {
     margin-top: 38px;
   }
   .footer_left .logo_partner_box .logo_partner {
     float: left;
   }
   .footer_left .logo_partner_box .logo_sns {
     float: left;
   }
   .footer_left .logo_partner_box .logo_partner img {
     margin-right: 17px;
   }
  /* 中间区块 */
  .footer .footer_code {
    padding: 8px 30px;
  }
  /* 右边区块 */
  .footer_right {
    overflow: hidden;
    display: flex;
  }
  .footer_right ul {
    float: left;
    margin-left: 30px;
  }
  .footer_right ul li {
    letter-spacing: 4px;
    cursor:pointer;
  }
  .footer_right ul li:first-child {
    font-weight: bold;
    margin-left: 0px;
  }
  .footer_right ul li+li {
    margin-top: 26px;
  }
/* copyright */
  .copyright {
    height: 68px;
    color: #777777;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }


      /*  */
@media screen and (max-width:768px){
  /* 显示/隐藏 */
  .footer_maxbox {
    display: none;
  }
}
</style>
